"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var strings_1 = require("./strings");
exports.MEMO_STATES = [strings_1.ACTIONED, strings_1.PENDING];
//# sourceMappingURL=memo-states.js.map